<template>
  <div>
    <UnauthorizedUserModal v-if="showErrorModal" :show="showErrorModal" title="Error" :message="modalMessage" :showLogin="showLoginLink" @close="showErrorModal = false" />

    <router-view />
  </div>
</template>

<script>
import { get, clearSessionAndRedirectToLogin } from '@/utils/api'
import UnauthorizedUserModal from './components/ConfirmationModal/UnauthorizedUserModal.vue'
import { showErrorModal, modalMessage, showLoginLink } from '@/stores/modalStore'

export default {
  components: {
    UnauthorizedUserModal,
  },
  data() {
    return {
      currentLanguage: localStorage.getItem('language') || 'en',
    }
  },
  computed: {
    showErrorModal: {
      get() {
        return showErrorModal.value
      },
      set(val) {
        showErrorModal.value = val
      },
    },
    modalMessage() {
      return modalMessage.value
    },
    showLoginLink() {
      return showLoginLink.value
    },
  },
  mounted() {
    const token = localStorage.getItem('AccessToken')
    const isAuthenticated = !!token

    // Initialize language
    this.$i18n.locale = this.currentLanguage

    if (isAuthenticated) {
      this.fetchUserRoles()
    }
  },
  methods: {
    changeLanguage() {
      this.$i18n.locale = this.currentLanguage
      localStorage.setItem('language', this.currentLanguage)
    },
    confirmLogout() {
      clearSessionAndRedirectToLogin()
    },
    async fetchUserRoles() {
      try {
        const userId = JSON.parse(localStorage.getItem('UserData'))?.id
        const tenant_id = JSON.parse(localStorage.getItem('UserData'))?.tenant_id
        if (!userId) return
        const roleResponse = await get(`/v1/user-roles/${userId}`)
        if (roleResponse?.data?.code === 200) {
          localStorage.setItem('UserRoles', JSON.stringify(roleResponse.data.data))
          localStorage.setItem('userRole', roleResponse.data.data[0]?.role?.roleName)
        } else {
        }
        const permissionsResponse = await get(`/v1/users/permissions/${userId}`)
        if (permissionsResponse?.data?.code === 200) {
          localStorage.setItem('permissions', JSON.stringify(permissionsResponse.data.data))
        }
        const tenantDetails = await get(`/v1/tenants/${tenant_id}`)
        if (tenantDetails?.data?.code === 200) {
          if (!tenantDetails.data.data.is_active) {
            this.confirmLogout()
          }
        }
      } catch (error) {}
    },
  },
}
</script>
